
import React, { useState } from 'react'
import {  Input } from 'antd'
import '../admin.css'
import { AdminDataTable } from '../AdminDataTable';
import { useGetAdminLogByIDQuery } from '../../../services/admin/admin.service'; 
import moment from 'moment'
import { useParams } from 'react-router-dom';


export const AdminLog = () => {
    const { Search } = Input;

    const [searchText, setSearchText] = useState('')
    const [filteredResults, setFilteredResults] = useState([]);
    const [order, setOrder] = useState("ACS");
    const { adminId } = useParams()

    const response = useGetAdminLogByIDQuery(adminId)

    const { data, isError, isFetching, isLoading, isSuccess, error } = response

    const _data = data?.data?.Items

    const onSearch = (value) => {
        setSearchText(value)
        if(value !== ''){
            const filteredData = _data.filter((item) => {
                return Object.values(item).join('').toLocaleLowerCase().includes(value.toLocaleLowerCase())
            })
            setFilteredResults(filteredData)
        }else{
            setFilteredResults(_data)
        }
    }


    const Sorting = (value) => {
        let sortedData;
        const field= value
        if (order === 'ACS') {
            sortedData = [..._data].sort((a, b) => {
            return a[field].localeCompare(b[field]);
            });
            setOrder("DCS")
        } else if (order === 'DCS') {
            sortedData = [..._data].sort((a, b) => {
                return b[field].localeCompare(a[field]);
            })
            setOrder("ACS")
        } else {
            return _data;
        }
        setSearchText("sort")
        setFilteredResults(sortedData)
    }

    const columns = [
        {
            key: "title",
            title: "Title",
            dataIndex: "title",
            onHeaderCell: (column) => {
                return {
                  onClick: () => {
                    Sorting("title")
                  }
                };
            }
        },
        {
            key: "email",
            title: "Email",
            dataIndex: "email",
            onHeaderCell: (column) => {
                return {
                  onClick: () => {
                    Sorting("email")
                  }
                };
            }
        },
        {
            key: "createdAt",
            title: "Date Added",
            dataIndex: "createdAt",
            render: (createdAt) => (
                <div>
                    {
                        moment(createdAt).format('L')
                    }
                </div>
            ),
            onHeaderCell: (column) => {
                return {
                  onClick: () => {
                    Sorting("createdAt")
                  }
                };
            },
        },
        {
            key: "lastLogIn",
            title: "Last log in",
            dataIndex: "updatedAt",
            render: (updatedAt) => (
                <div>
                    {
                        moment(updatedAt).format('L')
                    }
                </div>
            ),
            onHeaderCell: (column) => {
                return {
                  onClick: () => {
                    Sorting("updatedAt")
                  }
                };
            },
        },
    ]
  
    return (
            <div className='flex flex-col'>
                <div className='flex items-center justify-between flex-wrap-reverse'>
                    <div className='mt-4 md:w-1/3 w-full'>
                        <Search
                            placeholder="input search text"
                            onSearch={onSearch} />
                    </div>
                </div>

                <AdminDataTable
                    _data={ searchText ? filteredResults: _data}
                    columns={columns}
                    isError={isError}
                    isFetching={isFetching}
                    isLoading={isLoading}
                    error={error}
                    isSuccess={isSuccess}
                />
            </div>
            
    )
}

